import {BoxShadowValueRestDto, ColorSolidRestDto, CssDimensionRestDto} from "@/api/pharma-cms-content-page/models";
import {CssDimensionRestDtoModel} from "@/models/api/pharma-cms-content-page/CssDimensionRestDtoModel";
import {ColorSolidRestDtoModel} from "@/models/api/ColorSolidRestDtoModel";

export class BoxShadowValueRestDtoModel implements BoxShadowValueRestDto {
    h_offset: CssDimensionRestDto;
    v_offset: CssDimensionRestDto;
    blur_radius?: CssDimensionRestDto | null;
    spread_radius?: CssDimensionRestDto | null;
    is_inset: boolean;
    color?: ColorSolidRestDto | null;

    constructor(h_offset: CssDimensionRestDto, v_offset: CssDimensionRestDto, is_inset: boolean) {
        this.h_offset = h_offset;
        this.v_offset = v_offset;
        this.is_inset = is_inset;
    }

    static createWithDefaults(): BoxShadowValueRestDtoModel {
        const model: BoxShadowValueRestDtoModel = new this(
            CssDimensionRestDtoModel.createWithDefaults(),
            CssDimensionRestDtoModel.createWithDefaults(),
            false,
        );
        // No colour: an empty colour object would be sent as one, and the API takes a colour or
        // nothing. The editor fills it in as soon as one is picked.
        model.color = null;
        return model;
    }

    static cloneFrom(source: BoxShadowValueRestDto): BoxShadowValueRestDtoModel {
        const clone: BoxShadowValueRestDtoModel = new this(
            CssDimensionRestDtoModel.cloneFrom(source.h_offset),
            CssDimensionRestDtoModel.cloneFrom(source.v_offset),
            source.is_inset,
        );
        clone.blur_radius = source.blur_radius
            ? CssDimensionRestDtoModel.cloneFrom(source.blur_radius)
            : null;
        clone.spread_radius = source.spread_radius
            ? CssDimensionRestDtoModel.cloneFrom(source.spread_radius)
            : null;
        clone.color = source.color
            ? ColorSolidRestDtoModel.cloneFrom(source.color)
            : null;
        return clone;
    }
}
